import React, { memo } from 'react'
import { Grid } from '@mui/material'

import WalletConnectButtonWrapper from '../walletConnect/WalletConnectButtonWrapper'
import BaseCard from '../shared/baseCard/BaseCard'
import Text from '../shared/text/Text'
import QBXBanner from './QBXBanner'

const ConnectWalletForClaim = ({ t, isWalletConnected }) => {
  return (
    <BaseCard>
      <Grid container spacing={{ xs: 0, sm: 2 }} alignItems='center'>
        <Grid item xs={12} sm={4}>
          <QBXBanner />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Text
            variant='h2'
            label={t(
              isWalletConnected ? 'home.no-allocation' : 'home.connect-to-claim'
            )}
            fontWeight={700}
            sx={{ mb: 2 }}
          />
          <WalletConnectButtonWrapper
            t={t}
            customLabel={isWalletConnected && t('home.connect-other-wallet')}
          />
        </Grid>
      </Grid>
    </BaseCard>
  )
}

export default memo(ConnectWalletForClaim)
